import { render, staticRenderFns } from "./CardList-article.vue?vue&type=template&id=0375e5b7&"
import script from "./CardList-article.vue?vue&type=script&lang=js&"
export * from "./CardList-article.vue?vue&type=script&lang=js&"
import style0 from "./CardList-article.vue?vue&type=style&index=0&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports